import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SvgComponent() {
    return (
        <Svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
        >
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.144 3.917c2.974.042 5.384 2.782 6.606 5.083 0 0-.4.813-.803 1.377a13 13 0 01-.617.794c-.153.183-.312.361-.477.534-1.473 1.547-3.588 2.701-5.822 2.253C5.549 13.46 3.606 11.287 2.39 9c0 0 .35-.834.756-1.396a12.69 12.69 0 011.048-1.27c1.301-1.371 2.971-2.427 4.95-2.417zm-.01 1.125C7.477 5.036 6.1 5.96 5.01 7.109a11.664 11.664 0 00-.95 1.153c-.154.212-.298.507-.41.728 1.062 1.82 2.612 3.466 4.602 3.865 1.846.37 3.569-.647 4.786-1.925a11.756 11.756 0 00.994-1.208c.156-.219.322-.497.446-.722-1.109-1.872-2.995-3.922-5.344-3.958z"
                fill="#000"
            />
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.044 6.735A2.256 2.256 0 116.79 8.99a2.256 2.256 0 012.255-2.255zm0 1.128a1.128 1.128 0 110 2.256 1.128 1.128 0 010-2.256z"
                fill="#000"
            />
        </Svg>
    )
}

export default SvgComponent
